import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import store from "./Redux/Store";
import App from "./App";

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const ErrorFallback = (props: ErrorFallbackProps) => {
  useEffect(() => {
    props.resetErrorBoundary();
  }, []);
  return <div></div>;
};

const root = ReactDOM.createRoot(document.getElementById("root") as any);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// Installazione dell'app: il browser offre l'installazione una volta sola, appena la pagina si carica. Si tiene
// da parte qui, perche' quando si apre Impostazioni l'evento e' gia' passato (prima andava perso).
window.addEventListener("beforeinstallprompt", (e: any) => {
  e.preventDefault();
  (window as any).__installPrompt = e;
  window.dispatchEvent(new Event("install-prompt-ready"));
});
window.addEventListener("appinstalled", () => {
  (window as any).__installPrompt = null;
});

// Registrazione Service Worker per PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('✅ Service Worker registrato:', registration.scope);
      })
      .catch((error) => {
        console.error('❌ Registrazione Service Worker fallita:', error);
      });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
